$( document ).ready(function() {
  $('body').on('click', '.swatch-element' , function(){
    const val = $(this).find('input').val();
    let opt = null;
    $('.single-option-selector option').each( function(){
      if ( val == $(this).html() ){
        opt = $(this);
        $(this).attr('selected', true );
      } else {
        $(this).removeAttr('selected' );
      }
    })
    
    if ( opt !== null ){
      $('.single-option-selector').val( opt.html() );
      $('.single-option-selector').trigger('change');
    }
    
    //$('.single-option-selector')
  });
  
});
